import React from 'react'
import { BottleneckMessage } from '../domain/BottleneckMessage'
import Percent from '../helper/percent'

type Props = {
    message?: BottleneckMessage
}

export const BottleneckEstimatedImpact: React.FunctionComponent<Props> = ({ message }) => {
    if (!message || message.impact === 0) {
        return null
    }

    return (
        <h4 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>{message.label}</span>
            <span className="label label-outline-default">
                Estimated Impact: <Percent value={message.impact} />
            </span>
        </h4>
    )
}
